const Footer = () => {
  return (
    <div className='p-3 small text-muted text-center w-100'>
      &copy; {new Date().getFullYear()} Inspire Leadership Network. All rights reserved.
    </div>
  )
}

export default Footer
